import React from "react"
import styles from './Header.module.css'
import logo from '../../../assets/img/headerLogo.svg'
import { Link, NavLink } from "react-router-dom"
import { useSelector } from "react-redux";
import { ReactComponent as MenuSvg } from '../../../assets/img/nav/menu.svg'
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';

const Header = () => {
    const unreadCount = useSelector(
        (state) => state.notificationsSlice
            ? (state.notificationsSlice.items || []).filter(n => !n.is_read).length
            : 0
    );
    return (

        <header className={styles.header}>
            <div className={styles.headerWrapper}>
                <Link to='/'>
                    <img className={styles.logo} src={logo} />
                </Link>
            </div>
            <nav className={styles.nav}>
                <NavLink
                    className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}
                    to='/notifications'
                >
                    <Badge
                        color="error"
                        variant="dot"
                        overlap="circular"
                        invisible={!unreadCount}
                    >
                        <NotificationsIcon />
                    </Badge>
                </NavLink>
                <NavLink className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`} to='/'>
                    Главная
                </NavLink>
                <NavLink className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`} to='/news'>
                    Новости
                </NavLink>
                <NavLink className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`} to='/documents'>
                    Документы
                </NavLink>
                <NavLink className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`} to='/calendar'>
                    Календарь
                </NavLink>
                <a style={{ padding: '10px' }} className={styles.item}>
                    <MenuSvg />
                    <div className={styles.subMenu}>
                        <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/tickets'>Вопросы ОППО<div className={styles.circle}></div></NavLink>
                        <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/exchange-rates'>Курс валют<div className={styles.circle}></div></NavLink>
                        <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/work-calendar'>Производственный календарь<div className={styles.circle}></div></NavLink>
                        <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/pause'>Пауза<div className={styles.circle}></div></NavLink>
                        {/* <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/proposal'>Акции<div className={styles.circle}></div></NavLink> */}
                        <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/profile'>Личный кабинет<div className={styles.circle}></div></NavLink>
                        <NavLink className={({ isActive }) => `${styles.subMenuItem} ${isActive ? styles.itemActive : ''}`} to='/ticketsAbout'>Аппарат ОППО<div className={styles.circle}></div></NavLink>
                    </div>
                </a>
            </nav>
        </header>

    )
}
export default Header